import React from 'react';

export default () => <p>Page not found</p>;



// WEBPACK FOOTER //
// ./app/components/notFound.js